import React from 'react'
import { useTranslation } from 'react-i18next'
import './style.css'
import { Icon } from '@iconify/react/dist/iconify.js';

const ScreenHeader = ({children, title, subtitle, className = "", icon,}) => {
  const { t } = useTranslation();
  return (
    <div className={`screen-header ${className}`}>
      <div className="col">
        <div className="d-flex align-items-center gap-2">
          {icon && <Icon icon={icon} className="icon" />}
          <div className="title">{t(title)}</div>
        </div>
        {subtitle && <div className="subtitle">{t(subtitle)}</div>}
      </div>
      {children}
    </div>
  )
}

export default ScreenHeader